import FeatureGates, { FeatureGateEnvironment } from '@atlassian/feature-gate-js-client';
import type { WindowFlagVars } from '../types';
import { getMeta } from 'util/meta';
import { getFeatureFlagsFromMetaTag } from '../utils';

export function initialiseFeatureGates(vars: WindowFlagVars) {
    if (FeatureGates.initializeCalled()) {
        return Promise.resolve();
    }
    try {
        const cloudId = getMeta('ajs-cloud-id') ?? undefined;
        const atlassianAccountId = getMeta('ajs-atlassian-account-id');
        const region = getMeta('ajs-region');
        const environment =
            region !== undefined && region?.startsWith('prod')
                ? FeatureGateEnvironment.Production
                : FeatureGateEnvironment.Staging;

        return FeatureGates.initializeFromValues(
            {
                environment,
                targetApp: 'jsm-portal_web',
                sdkKey:
                    environment === FeatureGateEnvironment.Production
                        ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6'
                        : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1',
            },
            {
                atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
                tenantId: cloudId,
            },
            {},
            vars.statsigValues || getFeatureFlagsFromMetaTag('ajs-fe-statsig-values')
        );
    } catch (error) {
        return Promise.reject(error);
    }
}
